//src/Components/CompanyDetails/Register_Agent

import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { BASE_URL } from "../../Config"; // Ensure this is defined in your Config.js

const RegisterAgent = () => {
  const [userId, setUserId] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [address, setAddress] = useState("");
  const [cnic, setCnic] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [loading, setLoading] = useState(false);

  // Load userId from sessionStorage
  useEffect(() => {
    const storedUserData = sessionStorage.getItem("user");
    if (storedUserData) {
      const userData = JSON.parse(storedUserData);
      setUserId(userData.userId);
    } else {
      Swal.fire("Error", "No user data found in sessionStorage.", "error");
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name || !email || !password) {
      Swal.fire("Error", "Please fill all required fields!", "error");
      return;
    }

    const agentData = {
      userId,
      name,
      email,
      password,
      address,
      cnic,
      contactNumber,
    };

    setLoading(true);
    try {
      const response = await axios.post(`${BASE_URL}Register_Agent`, agentData, {
        headers: {
          "Content-Type": "application/json",
          accept: "*/*",
        },
      });

      // Show alert for success or error
      Swal.fire({
        title: response.data.responseCode === "0000" ? "Success" : "Error",
        text: response.data.message,
        icon: response.data.responseCode === "0000" ? "success" : "error",
      });

      // Clear form if success
      if (response.data.responseCode === "0000") {
        setName("");
        setEmail("");
        setPassword("");
        setAddress("");
        setCnic("");
        setContactNumber("");
      }

    } catch (error) {
      console.error("Register Agent Error:", error);
      Swal.fire("Error", "Something went wrong!", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-5">
      <div className="card p-4">
        <h2 className="text-center mb-4">Register New Agent</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">Name *</label>
            <input
              type="text"
              className="form-control"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Email *</label>
            <input
              type="email"
              className="form-control"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Password *</label>
            <input
              type="password"
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Address</label>
            <input
              type="text"
              className="form-control"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            />
          </div>

          <div className="mb-3">
            <label className="form-label">CNIC</label>
            <input
              type="text"
              className="form-control"
              value={cnic}
              onChange={(e) => setCnic(e.target.value)}
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Contact Number</label>
            <input
              type="text"
              className="form-control"
              value={contactNumber}
              onChange={(e) => setContactNumber(e.target.value)}
            />
          </div>

          <button type="submit" className="btn btn-primary w-100" disabled={loading}>
            {loading ? "Registering..." : "Register Agent"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default RegisterAgent;